<template>
  <pf-toggle-group>
    <pf-toggle-group-item :selected="modelValue === 'linux'" @click="emit('update:modelValue', 'linux')"><linux-icon /> Linux</pf-toggle-group-item>
    <pf-toggle-group-item :selected="modelValue === 'windows'" @click="emit('update:modelValue', 'windows')"><windows-icon /> Windows</pf-toggle-group-item>
  </pf-toggle-group>
</template>

<script setup lang="ts">
import { useWizardQuestion, type OperativeSystems } from '@/wizard';
import LinuxIcon from '@vue-patternfly/icons/linux-icon';
import WindowsIcon from '@vue-patternfly/icons/windows-icon';

defineProps<{
  modelValue: OperativeSystems;
}>();

const emit = defineEmits<{
  (name: 'update:modelValue', v: OperativeSystems): void;
}>();

useWizardQuestion();
</script>
